<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div>
    <template v-if="currentViewCreation === 'loading'">
      <b-loading
        is-full-page
        :active.sync="isLoading"
      >
        <div class="box loading">
          <div class="bloader">
            <div class="shape shape-1" />
            <div class="shape shape-2" />
            <div class="shape shape-3" />
            <div class="shape shape-4" />
          </div>
        </div>
      </b-loading>
    </template>
    <div
      v-if="currentViewCreation === 'creation'"
      id="page"
      class="container"
      :class="languageAbbrSelected"
    >
      <div class="box name">
        <center>
          <div class="welcome-creation">
            <h2>{{ $t("index.welcome") }}<span>!</span></h2>
            <h3>{{ $t("index.welcomesub") }}</h3>
          </div>
          <!-- <h3 id="hi_name">
            {{ $t('index.quiz', { name: theName }) }}
          </h3> -->
        </center>
        <div class="divider">
          <span />
        </div>
        <div class="quick-tips">
          <h3>{{ $t("index.quicktips") }}</h3>
          <b-carousel
            :arrow="true"
            :autoplay="false"
            :arrow-both="false"
            :arrow-hover="false"
            :indicator-position="'is-top'"
            :indicator-inside="false"
            :indicator-custom="true"
            :icon-pack="'fas'"
            :icon-prev="'angle-left'"
            :icon-next="'angle-right'"
          >
            <b-carousel-item
              v-for="(carousel, i) in carousels"
              :key="i"
            >
              <span class="image">
                <div :class="'quick_tips_'+(i + 1)" />
                <!-- <img :src="getImgUrl(i + 1)"> -->
              </span>
              <h4>{{ $t("index.quicktips"+(i + 1)) }}</h4>
            </b-carousel-item>
          </b-carousel>
        </div>
        <!-- <ul class="instructions">
          <li>
            <span class="dna v-left" /><span
              id="questions_page_desc"
              class="info_text v-right"
            >
              {{ $t('index.adn') }}
            </span>
          </li>
        </ul> -->
      </div>

      <div id="allquestions">
        <!-- ******************** QUESTIONS -->
        <template
          v-for="(questionEdit, index) in questionsEdit"
        >
          <div
            v-if="index <= 9"
            :id="'question_block_' + (index + 1)"
            :key="questionEdit.id"
            class="question_block_square"
            style="background-color: #ff2d55"
          >
            <span
              :id="'text_question_number_' + (index + 1)"
              class="question_text"
              style="vertical-align:top; justify-content:center; font-size:17px;background-color: #ff2d55;"
              :style="{ backgroundColor: colorOptions[questionEdit.color] }"
            >
              {{ $t('index.question', { number: (index + 1) }) }}
            </span>
            <div class="question">
              <b-input
                :id="'question_' + index"
                v-model="questionEdit.question"
                minlength="10"
                maxlength="100"
                rows="4"
                type="textarea"
                :placeholder="$t('index.questionplaceholder')"
                spellcheck="false"
              />
            </div>
            <b-dropdown aria-role="list">
              <button
                slot="trigger"
                class="fullWidthButton dropdown-toggle notopmargin"
              >
                <span class="caret" />
              </button>
              <!-- ******************** EXTRA QUESTIONS -->
              <template
                v-for="(questionCarte, itemIndex ) in questionsReverse"
              >
                <b-dropdown-item
                  v-if="itemIndex >= 0"
                  :key="questionCarte.id"
                  aria-role="listitem"
                  @click="extra_question_selected(index, itemIndex)"
                >
                  {{ questionCarte.question }}
                </b-dropdown-item>
              </template>
            </b-dropdown>
            <!-- ******************** OPTIONS -->
            <div class="options-wrap">
              <div
                v-for="(option, optionIndex ) in questionEdit.options"
                :key="option.id"
                class="option-wrap columns is-mobile is-gapless"
              >
                <b-radio
                  v-model="rightAnswers[index]"
                  :native-value="optionIndex"
                  class="column is-narrow"
                  :title="$t('index.correctanswertip')"
                />
                <b-input
                  :id="'textarea_question_' + index + '_option_' + optionIndex"
                  v-model="questionEdit.options[optionIndex]"
                  :class="{ right_answer: rightAnswers[index] === optionIndex }"
                  minlength="1"
                  maxlength="70"
                  rows="3"
                  type="textarea"
                  :placeholder="$t('index.possibleanswer')"
                  spellcheck="false"
                  class="column"
                  :has-counter="false"
                />
                <div class="column is-narrow delete-option-wrap">
                  <b-button
                    v-if="questionsEdit[index].options.length >= 2"
                    rounded
                    type="is-danger"
                    icon-pack="fas"
                    icon-right="times"
                    class="delete-option"
                    title="Remove this option"
                    @click="remove_option(optionIndex,index)"
                  />
                  <b-button
                    v-if="questionsEdit[index].options.length < 2"
                    rounded
                    disabled
                    type="is-danger"
                    icon-pack="fas"
                    icon-right="times"
                    class="delete-option"
                    @click="remove_option(optionIndex,index)"
                  />
                </div>
              </div>
            </div>
            <!-- <span style="color:black;">{{ colorsSelected[index] }}</span> -->
            <div class="add-option-wrap">
              <b-button
                v-if="questionsEdit[index].options.length <= 7"
                size="is-medium"
                class="add_option_button pushdown"
                @click="add_option(index)"
              >
                {{ $t("index.addoption") }}
              </b-button>
            </div>
            <div class="divider">
              <span
                :style="{ backgroundColor: colorOptions[questionEdit.color] }"
              />
            </div>
            <div class="color-options-title">
              <h4>{{ $t("index.pickcolor") }}</h4>
            </div>
            <div class="color-options-wrap">
              <b-radio
                v-for="(colorOption, colorIndex ) in colorOptions"
                id="color_button_1_0"
                :key="colorOption.id"
                v-model="questionEdit.color"
                type="radio"
                class="circle_button"
                :native-value="colorIndex"
                :style="{ color: colorOption }"
                :class="{ selected: questionEdit.color === colorIndex, notselected: questionEdit.color !== colorIndex }"
              >
                <span />
              </b-radio>
            </div>
          </div>
          <!-- <div v-if="(index + 1) == 2" id="waldo-tag-15193" :key="index.id" style="text-align: center;"/> -->
          <!-- <div v-if="(index + 1) == 4" id="waldo-tag-15190" :key="index.id" style="text-align: center;"/> -->
          <!-- <div v-if="(index + 1) == 6" id="waldo-tag-15191" :key="index.id" style="text-align: center;"/> -->
          <!-- <div
            v-if="(index + 1) == 1 || (index + 1) == 3 || (index + 1) == 5 || (index + 1) == 7 || (index + 1) == 9"
            :id="'ad_creation_' + (index + 1)"
          /> -->
        </template>
      </div>

      <div
        id="info_page"
        class="infobox"
      >
        <i class="fas fa-ellipsis-h" />
        <span id="note_on_page">
          Note:
        </span>
      </div>

      <div class="done_button_shadow">
        <button
          id="done_button"
          class="fullWidthButton button_2 pushdown"
          type="button"
          @click="done()"
        >
          {{ $t("index.saveshare") }}
        </button>
      </div>
    </div>
    <BakedCompo
      :quiz-id="quizId"
      :user-id="userId"
      :current-view-creation="currentViewCreation"
      :language-abbr-selected="languageAbbrSelected"
    />
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import { colorOptions } from '@/consts'
import cloneDeep from 'lodash/cloneDeep'
import BakedCompo from '@/components/BakedCompo.vue'

export default {
  name: 'CreationCompo',
  components: {
    BakedCompo
  },
  // eslint-disable-next-line
  props: [ 'currentView', 'theName', 'langLocation', 'questionsArray', 'userId', 'hasUser', 'languageAbbrSelected' ],
  data () {
    return {
      colorOptions: colorOptions,
      rightAnswers: [ null, null, null, null, null, null, null, null, null, null ],
      // rightAnswers: [ 1, 2, 3, 1, 1, 1, 1, 1, 1, 1 ],
      // colorsSelected: ['#ff2d55', '#ff6348', '#ffbb02', '#2dda75', '#5ac8fa', '#5251fe', '#af33eb', '#ff2d55', '#ff6348', '#2f3542'],
      questionsEdit: [],
      quizId: '',
      currentViewCreation: '',
      isLoading: true,
      questionsReverse: [],
      carousels: [
        { text: this.$t('index.quicktips1') },
        { text: this.$t('index.quicktips2') },
        { text: this.$t('index.quicktips3') }
      ],
      executed: false
      // playwireUnits: [
      //   {
      //     selectorId: 'ad_creation_1',
      //     type: 'leaderboard_btf'
      //   },
      //   {
      //     selectorId: 'ad_creation_3',
      //     type: 'leaderboard_btf'
      //   },
      //   {
      //     selectorId: 'ad_creation_5',
      //     type: 'leaderboard_btf'
      //   },
      //   {
      //     selectorId: 'ad_creation_7',
      //     type: 'leaderboard_btf'
      //   },
      //   {
      //     selectorId: 'ad_creation_9',
      //     type: 'leaderboard_btf'
      //   },
      //   {
      //     type: 'left_rail'
      //   },
      //   {
      //     type: 'right_rail'
      //   }
      // ],
      // tyched: false
    }
  },
  computed: {
    questionsArrayComp () {
      return this.questionsArray
    }
  },
  watch: {
    questionsArray: function (newVal, oldVal) {
      this.questionsEdit = cloneDeep(this.questionsArray)
      this.questionsEdit.length = 10
      this.questionsReverse = this.questionsArray.slice().reverse()
    },
    currentView: function () {
      this.currentViewCreation = cloneDeep(this.currentView)
    }
  },
  // updated () {
  //   if (this.currentViewCreation === 'creation' && !this.tyched) {
  //     this.initTyche()
  //     this.tyched = true
  //   }
  // },
  updated () {
    if ((this.currentViewCreation === 'creation') && !this.executed) {
      // console.log('heeey')
      // waldo.refreshTag('waldo-tag-15193')
      // waldo.refreshTag('waldo-tag-15190')
      // waldo.refreshTag('waldo-tag-15191')
      this.executed = true
    }
  },
  methods: {
    // initTyche () {
    //   // console.log('Tyche API@Creation is initialized')
    //   try {
    //     ramp.destroyUnits('all')
    //   } catch (e) {
    //     console.log('destroyUnits error: ', e)
    //   }
    //   ramp.addUnits(this.playwireUnits)
    //     .then(() => {
    //       ramp.displayUnits()
    //     // callback function
    //     }).catch((e) => {
    //       // catch errors
    //       console.log(e)
    //     })
    // },
    remove_option (optionIndex, index) {
      this.questionsEdit[index].options.splice(optionIndex, 1)
      if (this.rightAnswers[index] === optionIndex || (this.questionsEdit[index].options.length <= this.rightAnswers[index])) {
        this.rightAnswers[index] = null
      }
    },
    add_option (index) {
      let options = this.questionsEdit[index].options
      if (options.length <= 7) {
        options.push(
          ''
        )
      }
    },
    extra_question_selected (questionN, extraQuestionN) {
      let elemClonedTemp = cloneDeep(this.questionsReverse[extraQuestionN])
      this.questionsEdit.splice(questionN, 1, elemClonedTemp)
    },
    done () {
      let emptyQuestions = []
      let sendAlert = ''
      let emptyOptions = []
      let canContinue = true
      let fewAnswers = []
      let noRightAnswer = []
      // console.log(dataToSend)
      // if (this.rightAnswers[9] === null) {
      //  console.log(this.rightAnswers)
      // }
      for (let i = 0; i < this.questionsEdit.length; i++) {
        if (!this.questionsEdit[i].question.length) {
          emptyQuestions.push(' ' + (i + 1))
          sendAlert = 'missingQuestion'
          canContinue = false
        } else {
          // eslint-disable-next-line
          this.questionsEdit[i].question = this.questionsEdit[i].question.replace(/[&\\\#,+$~%.:;*<>{}|]/g, '')
          for (let j = 0; j < this.questionsEdit[i].options.length; j++) {
            if (!this.questionsEdit[i].options[j].length && (sendAlert !== 'missingQuestion')) {
              if (!emptyOptions.includes(' ' + (i + 1))) {
                emptyOptions.push(' ' + (i + 1))
              }
              sendAlert = 'missingOption'
              canContinue = false
            } else {
              // eslint-disable-next-line
              this.questionsEdit[i].options[j] = this.questionsEdit[i].options[j].replace(/[&\\\#,+$~%.:;*<>{}|]/g, '')
              if ((this.questionsEdit[i].options.length <= 1) && (sendAlert !== 'missingQuestion') && (sendAlert !== 'missingOption')) {
                fewAnswers.push(' ' + (i + 1))
                sendAlert = 'fewAnswers'
                canContinue = false
              }
            }
          }
          if ((this.rightAnswers[i] === null) && (sendAlert !== 'missingQuestion') && (sendAlert !== 'missingOption') && (sendAlert !== 'fewAnswers')) {
            noRightAnswer.push(' ' + (i + 1))
            sendAlert = 'noRightAnswer'
            canContinue = false
          } else {
            this.questionsEdit[i].answer = this.rightAnswers[i]
          }
        }
      }
      if (canContinue) {
        this.currentViewCreation = 'loading'
        let quizId = this.randomString(5, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ')
        this.quizId = quizId
        const sendIt = {
          qid: quizId,
          name: this.theName,
          questions: this.questionsEdit,
          langloc: this.langLocation,
          creator: this.userId
        }
        const sendUser = {
          uid: this.userId,
          quiz_created_id: quizId
        }
        const existentUser = {
          quiz_created_id: quizId
        }
        if (this.hasUser) {
          this.$http.post('https://bestiebackend.herokuapp.com/api/quizzes', sendIt)
          this.$http.patch('https://bestiebackend.herokuapp.com/api/users/created/' + this.userId, existentUser)
            .then(response => {
              // console.log(response)
              this.isLoading = false
              this.currentViewCreation = 'baked'
              window.scrollTo(0, 0)
            })
            .catch(error => {
              // console.log(error)
            })
        } else {
          this.$http.all([
            this.$http.post('https://bestiebackend.herokuapp.com/api/quizzes', sendIt),
            this.$http.post('https://bestiebackend.herokuapp.com/api/users/', sendUser)
          ])
            .then(response => {
              // console.log(response)
              this.isLoading = false
              this.currentViewCreation = 'baked'
              window.scrollTo(0, 0)
            })
            .catch(error => {
              // console.log(error)
            })
        }
      }
      // alert system
      if (sendAlert === 'missingQuestion') {
        this.danger(this.$tc('index.lackquestion', emptyQuestions.length, { number: emptyQuestions }))
      } else if (sendAlert === 'missingOption') {
        this.danger(this.$t('index.lackoption', { number: emptyOptions }))
      } else if (sendAlert === 'fewAnswers') {
        this.danger(this.$t('index.lackanswers', { number: fewAnswers }))
      } else if (sendAlert === 'noRightAnswer') {
        this.danger(this.$t('index.lackrightanswer', { number: noRightAnswer }))
      }
    },
    randomString (idlenght, abc123) {
      let stringGenerated = ''
      for (var i = idlenght; i > 0; --i) {
        stringGenerated += abc123[Math.round(Math.random() * (abc123.length - 1))]
      };
      return stringGenerated
    },
    setCurrentView (state) {
      this.currentViewCreation = state
    },
    danger (message) {
      this.$buefy.notification.open({
        closable: true,
        duration: 5000,
        message: message,
        position: 'is-top',
        type: 'is-danger',
        hasIcon: false
      })
    }
    // getImgUrl(value) {
    //     return `https://webestiefy.com/bestimages/quick_tips_dummy${value}.jpg`
    // }

  }
}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .right_answer>textarea{
    background-color: #55ca7c;
    text-shadow: 0 1.5px 0 rgba(0, 0, 0, 0.1);
  }
</style>
